module.exports = __webpack_public_path__ + "static/media/de_skrivhastighet_video.9c838f08.mp4";